import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { FullTable } from 'components';
import { sortListByKey } from 'utils';
import {resourceActions } from 'store';
import { ACCESS_ACTION_TYPE, accessBody, accessHead } from './constants';


export const Access = ({handleCheck, selectedList, disabled}) => {
  const resourceAccessList = useSelector((state) => state.resource.resourceAccessList);
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const info = history?.location?.state;


  useEffect(() => {
    dispatch(resourceActions.getResourceAccess(params?.id));
  }, []);


  return (
    <div className='access-table-wrapper'>
      <FullTable
        head={accessHead(handleCheck, resourceAccessList, selectedList, disabled)}
        body={accessBody(handleCheck, selectedList, disabled)}
        loadingType={ACCESS_ACTION_TYPE}
        list={sortListByKey(resourceAccessList, 'adminFullName', info)}
        noText={'Accesses'}
        activeRowId={''}
        margin={'0'}
      />
    </div>
  );
};
